//export const URL_CAD_REGISTRO_TERMINAL = 'https://localhost:7163'
//export const URL_CAD_REGISTRO_TERMINAL = 'https://lock.api.sicplug.com.br/admin'

export const URL_CAD_REGISTRO_TERMINAL = 'https://api.seculos.com.br/regterminal'
// export const URL_REPORTS = 'https://localhost:52273'
export const URL_REPORTS = 'https://adm.api.seculos.com.br'
// export const URL_REPORTS = 'https://localhost:52273'
//export const URL_CAD_REGISTRO_TERMINAL = 'http://localhost:3333/regterminal'
